import { HEADING_PREVIEW_TEXT, PARAGRAPH_PREVIEW_TEXT } from '../constants/text-samples';

const getFontQueryText = (fontName) =>
  HEADING_PREVIEW_TEXT.replace(/ /g, '') +
  PARAGRAPH_PREVIEW_TEXT.replace(/ /g, '') +
  fontName.replace(/ /g, '');

const linkFont = (fontFamily) => {
  const head = document.querySelector('head');
  const existingLinks = document.querySelectorAll('link');
  const isFontUsed = Array.from(existingLinks).find((link) => link.id === fontFamily);

  if (isFontUsed) {
    return;
  }

  const formattedFontFamily = fontFamily.replace(/ /g, '+');
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = `https://fonts.googleapis.com/css2?family=${formattedFontFamily}&text=${getFontQueryText(
    fontFamily
  )}&display=swap`;
  link.id = fontFamily;
  head.appendChild(link);
};

export default linkFont;
